import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { actions as dialogActions } from "@Store/Reducers/dialog";
import { ChannelActions } from "@Store";

type AiReportContextDialogProps = {
    channelId: string;
};

const AiReportContextDialogContent: React.FC<AiReportContextDialogProps> = ({
    channelId,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<any>();
    const [aiContext, setAiContext] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleProceed = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            await dispatch(
                ChannelActions.generateChannelReport(
                    channelId,
                    aiContext
                ) as any
            );
            dispatch(dialogActions.hideDialog());
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Box sx={{ py: 1 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
                {t("dialogs.channel.ai_context_title")}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
                {t("dialogs.channel.ai_context_body")}
            </Typography>

            <TextField
                fullWidth
                multiline
                minRows={4}
                value={aiContext}
                onChange={(e) => setAiContext(e.target.value)}
                placeholder={t("dialogs.channel.ai_context_placeholder")}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button
                    onClick={handleProceed}
                    variant="contained"
                    size="small"
                    color="secondary"
                    disabled={isSubmitting}
                    type="button"
                >
                    {isSubmitting
                        ? t("dialogs.channel.continue_to_report_loading")
                        : t("dialogs.channel.continue_to_report")}
                </Button>
            </Box>
        </Box>
    );
};

const AiReportContextDialogActions: React.FC = () => <></>;

export default {
    content: AiReportContextDialogContent,
    actions: AiReportContextDialogActions,
    title: "AI Report Context",
    showActons: false,
    disableCancelButton: true,
    isGuestData: false,
};
